
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"2560","height":"518","viewBox":"0 0 2560 518","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.30683e-05 379.809C668.098 577.776 2183.28 548.73 2560 379.809L2560 0.000244141L1280 0.000140988L4.90882e-05 3.78344e-05L1.30683e-05 379.809Z","fill":"#E4E9F4"}})])
          )
        }
      }
    